import {deviceService} from "@/services/DeviceService";
import {toast} from "vue3-toastify";
import {i18n} from "@/lang";

const state = {
    device: [],
    getDeviceRequest: {
        loading: false,
    },
    deleteDeviceRequest: {
        loading: false,
    }
}

const mutations = {
    setGetDeviceRequest(state, {loading, message}) {
        state.getDeviceRequest = {
            loading: loading,
            message: message,
        }
    },
    setDeleteDeviceRequest(state, {loading, message}) {
        state.deleteDeviceRequest = {
            loading: loading,
            message: message,
        }
    },
    updateDevice(state, newList){
        state.device = newList
    }
}

const actions = {
    getDevice({ commit }) {
        commit('setGetDeviceRequest', {loading: true});
        deviceService.getDeviceData()
            .then(response => {
                commit('setGetDeviceRequest', {loading: false});
                commit('updateDevice', response.data);
                console.log(response.data);
            })
            .catch(error => {
                commit('setGetDeviceRequest', {loading: false, message: error});
            })
    },
    deleteDevice({ commit, state }, device) {
        deviceService.deleteDevice(device)
            .then(() => {
                toast.success(i18n.global.t("toast.deleteSuccess"));
                const updatedList = state.device.filter(element => element.serialNumber !== device.serialNumber);
                commit('updateDevice', updatedList);
            })
            .catch(error => {
                toast.error(i18n.global.t("toast.deleteError"));
                commit('setDeleteDeviceRequest', {loading: false, message: error});
            })
    }
}
export const device = {
    namespaced: true,
    state,
    mutations,
    actions
}